import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function unblockAffectedStaffPas(id: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.unblockAffectedStaffPas.url, { id }))
    .post()
}
